import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.ul`
  padding-left: 0;
  margin-bottom: -${sv.spacing.xlarge};

  list-style: none;
`
export default { Block }
